﻿import React, { useState, useEffect } from 'react';
import { LookupItem } from '../models/lookup-item';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import { CrudFunctions } from '../utilities/crud-functions';
import DataTemplates from '../templates/data-templates';
import { CommonDataStore } from '../store/commonDataStore';

import DataGrid, {
    Column,
    Paging,
    ColumnFixing,
    Toolbar,
    Item as ToolbarItem,
    LoadPanel
} from 'devextreme-react/data-grid';

import List from 'devextreme-react/list';
import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import Button from 'devextreme-react/button';

export default function BenchSheetSettings() {
    const [benchSheetList, setBenchSheetList] =
        useState<LookupItem[]>();

    const [selectedBenchSheet, setSelectedBenchSheet] =
        useState<LookupItem>();

    const [imageTypes, setImageTypes] =
        useState<LookupItem[]>();

    const [uoms, setUoms] =
        useState<LookupItem[]>();
        
    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    return (
        <div>
            <div className="lq-title-bar">
                <div className="lq-main-title">Bench Sheet Settings</div>

                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <div>
                        <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                            hint="go back"
                            height={'2.6em'}
                            onClick={goBack} />
                    </div>
                </div>
            </div>

            <div className="pw-comp-row pw-margin-top-05">
                <div className="pw-form-unit pw-comp-20">
                    <div className="pw-form-unit-label">Bench Sheets</div>
                    <List id="benchSheetsList"
                        className="pw-list-border"
                        height="70vh"
                        items={benchSheetList ? benchSheetList : []}
                        keyExpr="id"
                        showSelectionControls={false}
                        selectionMode="single"
                        itemRender={DataTemplates.LookupItemTitleDescriptionRender}
                        onOptionChanged={selectedBenchSheetChanged} />
                </div>

                <div>
                    <div className="lq-sub-title pw-margin-left-05 pw-margin-top-05 pw-margin-bottom-05">{selectedBenchSheet && selectedBenchSheet.description}</div>

                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-30">
                            <div className="pw-form-unit-label">Bench Sheet Label</div>
                            <TextBox id="benchSheetLabel" className="textbox"
                                onValueChanged={onBenchSheetLabelChanged}
                                maxLength={10}
                                showClearButton={true}
                                placeholder="na" value={selectedBenchSheet ? selectedBenchSheet.description : undefined} />

                        </div>
                        <div className="pw-form-unit pw-margin-top-08">
                            <Button icon="edit" type="normal" />
                        </div>
                    </div>

                    <div className="pw-comp-row pw-margin-top-05">
                        <div className="pw-form-unit pw-comp-30">
                            <div className="pw-form-unit-label">Image Types</div>
                            <List id="imageTypesList"
                                className="pw-list-border"
                                height="12rem"
                                items={imageTypes ? imageTypes : []}
                                keyExpr="id"
                                showSelectionControls={true}
                                selectionMode="multiple"
                                itemRender={DataTemplates.EhsTemplate}
                            />
                        </div>
                    </div>

                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-30">
                            <div className="pw-form-unit-label">Field</div>
                            <SelectBox id="uomsSelectBox" className="textbox"
                                onValueChanged={onBenchSheetLabelChanged}
                                placeholder="na" value={selectedBenchSheet ? selectedBenchSheet.description : undefined} />

                        </div>
                    </div>

                    <div className="pw-comp-row pw-margin-top-05">
                        <div className="pw-form-unit pw-comp-30">
                            <div className="pw-form-unit-label">UOMs</div>
                            <List id="uomsList"
                                className="pw-list-border"
                                height="12rem"
                                items={uoms ? uoms : []}
                                keyExpr="id"
                                showSelectionControls={true}
                                selectionMode="multiple"
                                itemRender={DataTemplates.EhsTemplate}
                            />
                        </div>
                    </div>
                </div>

            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    function onBenchSheetLabelChanged(e: any) {
        let editedBenchSheet = { ...selectedBenchSheet };
        editedBenchSheet.description = e.value;

        setSelectedBenchSheet(editedBenchSheet);
    }

    function selectedBenchSheetChanged(e: any) {
        if (e.name === 'selectedItems') {
            console.log("selectedBenchSheetChanged:");
            console.log(e);

            if (e.value && e.value.length > 0)
                setSelectedBenchSheet(e.value[0]);

        }
    }

    async function getAllData() {
        await Promise.all([
            getBenchSheetList(),
            getImageTypes(),
            getUoms()
        ]);
    }

    async function getBenchSheetList() {
        await CrudFunctions.getData("common/technologytypes")
            .then((data) => {
                setBenchSheetList(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Bench Sheet List");
            });
    }

    async function getImageTypes() {
        await CrudFunctions.getData("common/imagetypes")
            .then((data) => {
                setImageTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Image Types");
            });
    }

    async function getUoms() {
        const res = await CommonDataStore.getAllUoms();

        setUoms(res);
    }

    //other

    function goBack() {
        history.back();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

}



